export const QR_PREFIX = "stihiya:bonus:";
/** Доля от суммы чека при генерации QR по сумме (согласовано с backend `RECEIPT_BONUS_PERCENT`) */
export const RECEIPT_BONUS_PERCENT = 3;
